export default {
  DIGITAL: 1,
  WILL_CALL: 2,
  PRINT_AT_HOME: 3,
  AVE_OF_AMERICAS: 4,
};
